export default __webpack_public_path__ + "assets/ic-clover-logo.svg";